import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import SteelBuildingEstimatesWrapper from "@components/layouts/steelbuildingestimatesWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function SteelBuildingEstimatesHome(): ReactElement {
    return (
        <SteelBuildingEstimatesWrapper>
            <PrivacyPolicy
                category="Steel Buildings"
                domain="SteelBuildingEstimates.com"
            />
        </SteelBuildingEstimatesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
